import { getIn, useFormikContext } from "formik";
import AutocompleteAsyncFormik from "../../../../../common/components/form/AutocompleteAsyncFormik";
import { createDebounce } from "../../../../../common/helpers/debounce.helper";
import { Period, getPeriods } from "../../../../../common/services/plans.api";

const getPeriodDebounced = createDebounce(getPeriods, 100)

export function AvailablePeriodsFieldFormik() {
  const formik = useFormikContext();
  const contractType = getIn(formik.values, 'contractType');

  const loadOptions = async () => {
    const result = await getPeriodDebounced({
    }) as { ok: boolean, data: Period[] }

    const availablePlansMotoClub = /moto/.test(contractType) ? result.data.filter((item) => item.label.includes('Moto')) : result.data;
    if (!result.ok) {
      return []
    }

    const options = (availablePlansMotoClub).map((item) => Object.assign(item, { label: `${item.label}` }))

    return options
  }

  return (
    <AutocompleteAsyncFormik
      label="Período"
      name="period"
      valueProperty="label"
      loadOptions={loadOptions}
    />
  )
}